import type { V1BillingTier, V2BillingTier } from "schemas/generated/billing";

import { getPublisherUrl } from "@editor/utils/env";

export const getStripePortalUrl = (workspaceId: string) => {
  const url = new URL(`${getPublisherUrl()}/api/v1/stripe/portal`);
  url.searchParams.append("workspaceId", workspaceId);
  url.searchParams.append("returnUrl", window.location.href);
  return url.toString();
};

export const getPlanRank = (tier: V1BillingTier | V2BillingTier) => {
  const planRanks = {
    free: 0,
    basic: 1,
    starter: 1,
    pro: 2,
    standard: 2,
    growth: 3,
    custom: 4,
  };
  return planRanks[tier as keyof typeof planRanks] ?? 0;
};
